import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import LoginRoute from './LoginRoute';
import LoadingBar from 'react-top-loading-bar';
import Cookies from 'js-cookie';


import Header from './Header/Header';
import Footer from './Footer/Footer';
import Main from './Main/Main';
import Blogs from './Blog/Blogs';
import BlogPage from './Blog/BlogPage';
import Projects from './Project/Projects';
import ProjectPage from './Project/ProjectPage.js';
import ConnectionLost from './ErrorPages/ConnectionLost';
import Login from './Login/Login';
import Admin from './Admin/Admin';

const Component = () => {

	const [ progressBar, setProgressBar ] = React.useState( 0 );
	const [ offline, setOffline ] = React.useState( false );

	const setSession = ( name, value ) => {
		Cookies.set( name, value, { secure: true } );
	} 

	const getSession = ( name ) => {
		return Cookies.get( name );
	} 

	const setProgress = ( value ) => {
		setProgressBar( value );
	}

	const MINUTE_MS = 10000;

	React.useEffect(() => {

	    window.oncontextmenu = function () {
			return false;
		};
		
		document.addEventListener("keydown", function(event){
			var key = event.key || event.keyCode;
		
			if (key == 123) {
				return false;
			} else if ((event.ctrlKey && event.shiftKey && key == 73) || (event.ctrlKey && event.shiftKey && key == 74)) {
				return false;
			}
		}, false);

	  const interval = setInterval(() => {
		
		fetch( 'https://api.subrataghosh.repl.co/' )
        .then( ( resp ) => resp.text() )
        .then( ( data ) => setOffline( false ) )
        .catch( ( e ) => setOffline( true ) );

	  }, MINUTE_MS);
	
	  return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
	}, []);

	console.log('%c Stop!','font-weight: bold; font-size: 50px;color: red; text-shadow: 3px 2px 3px #ff0000, 0px 2px 3px #0000ff;');
	console.log( '%cThis is a browser feature intended for developers. Be careful!','font-size: 20px' );

	return (
		<BrowserRouter>
			<>
				<LoadingBar
					color='lime'
					progress={progressBar}
					onLoaderFinished={() => setProgressBar( 0 )}
				/>
				<Header />
				<Routes>
					<Route path='/' element={<Main onLoad={setProgress} />}/>
					<Route path='/projects' element={<Projects onLoad={setProgress} />}/>
					<Route path='/projects/:id' element={<ProjectPage onLoad={setProgress} />}/>
					<Route path='/apis' element={<>API</>}/>
					<Route path='/blogs' element={<Blogs onLoad={setProgress} />}/>
					<Route path='/blogs/:id' element={<BlogPage onLoad={setProgress} />}/>
					<Route path='/login' element={
						<LoginRoute redirectTo='/admin' getCookie={getSession} >
            				<Login setLoginSession={setSession} getCookie={getSession} onLoad={setProgress} />
          				</LoginRoute>
        				}
      				/>
					<Route path='/admin/*' element={
						<ProtectedRoute redirectTo='/login' getCookie={getSession} >
            				<Admin onLoad={setProgress} />
          				</ProtectedRoute>
        				}
      				/>
					<Route path='*' element={<h1>NOT FOUND</h1>}/>
				</Routes>
				{ offline && <ConnectionLost/>}
				<Footer/>
			</>
		</BrowserRouter>
	);
}

export default Component;